import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { RadioButtons } from '@grandvisionhq/forms';
import { H2, H3 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { useNearestStore } from '../../../modules/ServiceStore/hooks/use-nearest-store.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../state.js';
import '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import 'motion/react';
import { EditableLoyaltyPointsSummary } from '../../../StepOverview/EditableSummaries/EditableLoyaltyPointsSummary.js';
import { CustomerType } from '../../../types.js';
import { useLoggedInCheckout } from '../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { useUserStateConfig } from '../../hooks/useUserStateConfig.js';
import { AddressSummary } from './Summary/AddressSummary.js';
import { CompanySummary } from './Summary/CompanySummary.js';
import { ContactDetailsSummary } from './Summary/ContactDetailsSummary.js';
import { InvoiceSummary } from './Summary/InvoiceSummary.js';
import { ServiceStoreSummary } from './Summary/ServiceStoreSummary.js';

const UserDetails = ()=>{
    var ref2, ref1;
    const { billingAddress , contactDetails , storeCode , areUserDetailsLoading , error , isUserLoggedIn ,  } = useUserStateConfig();
    const { userDetailsState , setUserDetailsState , isCompanyOrder , isPickupOrder , shippingState , setShippingState , setIsCompany , areOrderDetailsValid , areAddressesEqual , isFailedToFetchUserData , setIsFailedToFetchUserData , setIsUserLoggedIn ,  } = useLoggedInCheckout();
    const { getLabel  } = useIntl();
    const { features , serviceStore: serviceStore1  } = useCheckoutSettings();
    const isServiceStoreValid = React.useMemo(()=>{
        return !(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) || shippingState.serviceStore || (serviceStore1 === null || serviceStore1 === void 0 ? void 0 : serviceStore1.isOptional);
    }, [
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        serviceStore1 === null || serviceStore1 === void 0 ? void 0 : serviceStore1.isOptional,
        shippingState.serviceStore
    ]);
    const { cart  } = Context.useCart();
    const labels = React.useMemo(()=>{
        return {
            customerType: {
                private: getLabel('checkout.customerType.private'),
                company: getLabel('checkout.customerType.company')
            },
            serviceStore: {
                title: `${getLabel('checkout.serviceStore.title')} ${(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && (serviceStore1 === null || serviceStore1 === void 0 ? void 0 : serviceStore1.isOptional) ? `(${getLabel('checkout.form.field.optional').toLowerCase()})` : ''}`
            }
        };
    }, [
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        getLabel,
        serviceStore1 === null || serviceStore1 === void 0 ? void 0 : serviceStore1.isOptional
    ]);
    const cartServiceCode = React.useMemo(()=>{
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.serviceStore) === null || ref === void 0 ? void 0 : ref.code;
    }, [
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.serviceStore) === null || ref2 === void 0 ? void 0 : ref2.code
    ]);
    const serviceStoreCode = React.useMemo(()=>{
        var ref;
        return ((ref = shippingState.serviceStore) === null || ref === void 0 ? void 0 : ref.code) || storeCode;
    }, [
        (ref1 = shippingState.serviceStore) === null || ref1 === void 0 ? void 0 : ref1.code,
        storeCode
    ]);
    const syncUserDetailsState = React.useCallback(()=>{
        setUserDetailsState(swcHelpers.objectSpread({}, userDetailsState, !userDetailsState.billingAddress ? {
            billingAddress
        } : {}, !userDetailsState.contactDetails ? {
            contactDetails
        } : {}, !userDetailsState.deliveryAddress ? {
            deliveryAddress: undefined
        } : {}, !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.invoice) ? {
            invoice: undefined
        } : {}, !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.company) ? {
            company: undefined
        } : {}));
        if (!userDetailsState.deliveryAddress) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                areAddressesEqual: true
            }));
        }
    }, [
        billingAddress,
        contactDetails,
        setShippingState,
        setUserDetailsState,
        shippingState,
        userDetailsState, 
    ]);
    const saveFormDetails = React.useCallback((formData)=>{
        if (!formData) return;
        setUserDetailsState(swcHelpers.objectSpread({}, userDetailsState, formData));
    }, [
        setUserDetailsState,
        userDetailsState
    ]);
    const updateServiceStore = React.useCallback((serviceStore)=>{
        setShippingState(swcHelpers.objectSpread({}, shippingState, {
            serviceStore
        }));
    }, [
        setShippingState,
        shippingState
    ]);
    const handleAddressEqual = React.useCallback((value)=>{
        setShippingState(swcHelpers.objectSpread({}, shippingState, {
            areAddressesEqual: value
        }));
    }, [
        setShippingState,
        shippingState
    ]);
    const handleFocusForError = ()=>{
        if (typeof window !== 'undefined') {
            const topErrorField = window.document.querySelector('div[role="alert"].alert-m-default');
            if (topErrorField) {
                topErrorField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                topErrorField === null || topErrorField === void 0 ? void 0 : topErrorField.focus();
            }
        }
    };
    const nearestStoreQuery = React.useMemo(()=>{
        if (billingAddress) {
            const postalCode = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) || '';
            const streetName = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetName) || '';
            const streetNumber = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetNumber) || '';
            const city = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city) || '';
            return `${postalCode} ${streetName} ${streetNumber} ${city}`.replace(/\s{2,}/g, ' ').trim();
        }
        return '';
    }, [
        billingAddress
    ]);
    const [code, isLoading] = useNearestStore(nearestStoreQuery, !storeCode && !serviceStoreCode && !!(serviceStore1 === null || serviceStore1 === void 0 ? void 0 : serviceStore1.preselectFromShippingData));
    React.useEffect(()=>{
        if (!areUserDetailsLoading) {
            syncUserDetailsState();
        }
        if (!areOrderDetailsValid) {
            setTimeout(()=>handleFocusForError()
            , 100);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        areUserDetailsLoading,
        areOrderDetailsValid
    ]);
    const handleUserDataFetchError = React.useCallback(()=>{
        if (isFailedToFetchUserData) return;
        if (!isFailedToFetchUserData) {
            setIsFailedToFetchUserData(true);
        }
    }, [
        isFailedToFetchUserData,
        setIsFailedToFetchUserData
    ]);
    React.useEffect(()=>{
        if (error) {
            handleUserDataFetchError();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    React.useEffect(()=>{
        if (isUserLoggedIn) {
            setIsUserLoggedIn(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isUserLoggedIn
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-small"
    }, getLabel('checkout.instant.userDetails.heading')), /*#__PURE__*/ React.createElement(H3, {
        variant: "text-body"
    }, getLabel('checkout.instant.userDetails.subheading')), Boolean(features === null || features === void 0 ? void 0 : features.isCompanyEnabled) && /*#__PURE__*/ React.createElement(RadioButtons, {
        scope: "orderType",
        alignment: "horizontal",
        onChange: (radioState)=>setIsCompany(radioState.value === CustomerType.Company)
        ,
        initialValue: isCompanyOrder ? CustomerType.Company : CustomerType.Private,
        items: [
            {
                value: CustomerType.Private,
                label: labels.customerType.private
            },
            {
                value: CustomerType.Company,
                label: labels.customerType.company
            }, 
        ]
    }), /*#__PURE__*/ React.createElement(AddressSummary, {
        address: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.billingAddress,
        deliveryAddress: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.deliveryAddress,
        isPickupOrder: isPickupOrder,
        onSubmit: saveFormDetails,
        areOrderDetailsValid: areOrderDetailsValid,
        areAddressesEqual: areAddressesEqual,
        handleAddressEqual: handleAddressEqual
    }), /*#__PURE__*/ React.createElement(ContactDetailsSummary, {
        onSubmit: saveFormDetails,
        contactDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.contactDetails,
        areOrderDetailsValid: areOrderDetailsValid,
        isFailedToFetchUserData: isFailedToFetchUserData
    }), !isCompanyOrder ? /*#__PURE__*/ React.createElement(InvoiceSummary, {
        onSubmit: saveFormDetails,
        invoiceDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.invoice,
        areOrderDetailsValid: areOrderDetailsValid
    }) : /*#__PURE__*/ React.createElement(CompanySummary, {
        onSubmit: saveFormDetails,
        companyDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.company,
        areOrderDetailsValid: areOrderDetailsValid
    }), /*#__PURE__*/ React.createElement(EditableLoyaltyPointsSummary, null), (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && !isPickupOrder && !isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ServiceStoreSummary, {
        code: serviceStoreCode || code,
        cartStoreCode: cartServiceCode,
        updateStore: updateServiceStore,
        title: labels.serviceStore.title,
        isServiceStoreValid: Boolean(isServiceStoreValid),
        areOrderDetailsValid: areOrderDetailsValid
    })));
};

export { UserDetails };
//# sourceMappingURL=UserDetails.js.map
